import { Button } from '@/components/ui/button.tsx';
import { useTelegram } from '../../../context/TelegramContext';
import {
  THEME_TOGGLE_OPTIONS,
  themePreferenceToToggleValue,
  useThemePreference,
} from '../../../context/ThemePreferenceContext';
import { SettingsFormCard, SettingsHubPage } from '../settings-shared';

export function SettingsAppearancePage() {
  const { webApp } = useTelegram();
  const { preference: themePreference, setPreference: setThemePreference } = useThemePreference();

  return (
    <SettingsHubPage title="Оформление">
      <SettingsFormCard title="Тема" description="Следует системной, светлая или тёмная.">
        <div className="flex w-full gap-2">
          {THEME_TOGGLE_OPTIONS.map((option) => {
            const active = themePreferenceToToggleValue(themePreference) === option.toggleValue;
            return (
              <Button
                key={option.toggleValue}
                type="button"
                variant={active ? 'default' : 'outline'}
                className="flex-1"
                onClick={() => {
                  setThemePreference(option.value);
                  webApp?.HapticFeedback?.selectionChanged();
                }}
              >
                <span className="mr-1.5" aria-hidden>{option.emoji}</span>
                {option.label}
              </Button>
            );
          })}
        </div>
      </SettingsFormCard>
    </SettingsHubPage>
  );
}
